import React, { memo } from 'react';
import {
  RelativeOneDiv,
  BlueDot,
  LogoWrapper,
  LogoImgWrapper,
  InnerWrapper,
  LogoImg,
  LogoTextBlock,
  LogoButton
} from './styled';
import type { MapMarkerOverlayProps } from '../types';
import useScreenSize from '../../../hooks/useScreenSize';

export const MapMarkerOverlay = memo(
  ({
    item,
    idx,
    stackIndex,
    hoveredIdx,
    setHoveredIdx,
    showModal,
    isModalOpen,
    setSelectedItem,
    setModalOpen,
    t
  }: MapMarkerOverlayProps) => {
    const { isSmall, isTablet } = useScreenSize();

    const handleActive = () => {
      if (!isSmall && !isTablet) setHoveredIdx(idx);
    };
    const handleInactive = () => {
      if (!isSmall && !isTablet) setHoveredIdx(null);
    };

    const handleAction = (e: React.SyntheticEvent | React.KeyboardEvent) => {
      e.stopPropagation();
      e.preventDefault();
      if (showModal && !isModalOpen) {
        setSelectedItem(item);
        setModalOpen(true);
      } else {
        window.open(item.path || item.url, '_blank');
      }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        handleAction(e);
      }
    };

    return (
      <RelativeOneDiv>
        <BlueDot />
        <LogoWrapper
          $active={hoveredIdx === idx}
          $stackIndex={stackIndex}
          onMouseEnter={handleActive}
          onFocus={handleActive}
          onMouseLeave={handleInactive}
          onBlur={handleInactive}
          onClick={handleAction}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          role="button"
          aria-label={item.name}
          title={item.name}
          data-cy={`pasha-map-marker-${idx}`}
          data-stat="map-label"
        >
          <InnerWrapper $active={hoveredIdx === idx}>
            <LogoImgWrapper $active={hoveredIdx === idx}>
              <LogoImg
                src={item.coverUrl}
                alt={item.name}
                $active={hoveredIdx === idx}
              />
            </LogoImgWrapper>
            <LogoTextBlock
              $active={hoveredIdx === idx}
              data-cy={`pasha-map-marker-info-${idx}`}
            >
              <strong>{item.name}</strong>
              {item.address && <p>{item.address}</p>}
              <LogoButton
                href={item.path || item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('pasha.details')}
              </LogoButton>
            </LogoTextBlock>
          </InnerWrapper>
        </LogoWrapper>
      </RelativeOneDiv>
    );
  }
);

MapMarkerOverlay.displayName = 'MapMarkerOverlay';
